module.exports = __webpack_public_path__ + "img/reservationTotal.b082ec28.svg";